import { Suspense } from "react";
import { VersionedContent } from "@circle-react/components/Layout/VersionedContent";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const PagesComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "PagesPage" */ "@circle-react/components/Site/Pages"
    ),
);

export const PagesPage = () => (
  <VersionedContent fullWidth>
    <Suspense fallback={<PageLoader />}>
      <PagesComponent />
    </Suspense>
  </VersionedContent>
);
